import { PackageActionType, PackageAction } from '../actions/PackageActions';
import { Package } from '../types/api/enrollmentPackages/Package';
import { Nullable } from '../types/custom/Nullable';

export interface PackageState {
    activePackage: {
        data: Nullable<Package>,
        loading: boolean,
        error: unknown // These are poorly thought out, not typing it in protest.
    }
}

const INITIAL_STATE: PackageState = {
    activePackage: {
        data: null,
        loading: false,
        error: null,
    }
};

export default function (state = INITIAL_STATE, action: PackageAction): PackageState {
    switch(action.type) {
        case PackageActionType.FETCH_PACKAGE_INFO:
            return {
                ...state,
                activePackage: {
                    data: null,
                    error: null,
                    loading: true
                }
            };
        case PackageActionType.FETCH_PACKAGE_INFO_SUCCESS:
            return {
                ...state,
                activePackage: {
                    data: action.payload,
                    error: null,
                    loading: false
                }
            };
        case PackageActionType.FETCH_PACKAGE_INFO_FAILURE: {
            return {
                ...state,
                activePackage: {
                    data: null,
                    error: action.payload,
                    loading: false
                }
            };
        }
        default:
            return state;
    }
}